export default {
  // TODO Needs to be updated
  privacy: '',
  terms: '',
};



// WEBPACK FOOTER //
// ./js/lang/en/links.js